import { render, staticRenderFns } from "./hzIndex.vue?vue&type=template&id=8883330a&scoped=true&"
import script from "./hzIndex.vue?vue&type=script&lang=js&"
export * from "./hzIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8883330a",
  null
  
)

export default component.exports